<template>
    <div class="content-wrapper">
        <swiper :options="swiperOptions" ref="mySwiper">
            <swiper-slide v-for="(item, index) in banners" :key="index">
                <img :src="require('@/assets/' + item.img + '.png')" class="banner-img" />
                <div class="text">
                    <div class="title" style="white-space: pre-line;">{{ item.title }}</div>
                    <div class="subtitle">{{ item.subtitle }}</div>
                </div>
            </swiper-slide>
            <div class="swiper-pagination" slot="pagination"></div>
        </swiper>
        <div class="data-display">
            <div class="data-item" v-for="e in businessData" :key="e.num">
                <img :src="require('@/assets/' + e.img + '.png')" alt="">
                <div class="text">
                    <div class="num">
                        <count-to :start-val="e.num / 1.4" :end-val="e.num" :duration="2000" :decimals="2"
                            :useEasing="true"></count-to>
                        <span class="unit">{{ e.unit }}</span>
                    </div>
                    <div class="desc">{{ e.desc }}</div>
                </div>
            </div>
        </div>
        <div class="public-box ">
            <div class="title">我们的优势</div>
            <div class="slide">
                <swiper :options="swiperOptions1" ref="mySwiper1">
                    <swiper-slide v-for="(item, index) in advantageData" :key="index">
                        <div class="item" :style="{backgroundImage: 'url(' + require('@/assets/slide_small'+ (index+1) + '.png') + ')'}">
                            <div class="mini-title">{{item.title}}</div>
                            <div class="subtitle">{{ item.subtitle}}</div>
                        </div>
                    </swiper-slide>
                </swiper>
            </div>
        </div>
        <div class="public-box wrap-bg">
            <div class="title">客户见证</div>
            <div class="imgList">
                <div v-for="item in 2" :key="item" class="list l-list">
                    <div class="item l-item" v-for="el in 8" :key="el"><img :src="require('@/assets/kh-'+(el-1)+'.png')" alt=""></div> 
                </div>
            </div>
            <div class="imgList">
                <div v-for="item in 2" :key="item" class="list r-list">
                    <div class="item r-item" v-for="el in 14" :key="el" v-if="el>6" ><img :src="require('@/assets/kh-'+(el)+'.png')" alt=""></div> 
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import countTo from 'vue-count-to';
export default {
    components: {
        countTo,
    },
    data() {
        return {
            banners: [
                { img: 'banner_img1', title: '神鸟云 \n数字供应链综合云平台', subtitle: '以边缘计算+5G 技术为核，提供 “采购-分发-运营-增值” 全链路服务，服务百度、腾讯、抖音等 120 + 头部企业，权益分发成功率 99.98%、平均延迟＜1秒' },
                { img: 'banner_img2', title: '交易放心，服务省心 \n皆淘淘助力前行', subtitle: '聚合超上百家品牌直签资源，涵盖影视、生活、商超等全场景权益商品，确保货源稳定、价格优势显著' },
                { img: 'banner_img3', title: '充值采购', subtitle: '特价充值则专为价格敏感型用户量身打造，以极具吸引力的优惠价格为核心优势。' }
            ],
            businessData: [
                { img: 'icon1', num: 133.81, unit: 'W', desc: '近24小时成交GMV' },
                { img: 'icon3', num: 34, unit: '万', desc: '近24小时成交订单数' },
                { img: 'icon2', num: 7280, unit: '', desc: '商品数量' },
                { img: 'icon4', num: 4.5, unit: '万', desc: '入住商家' },

            ],
            advantageData: [
                {title: '全牌照合规保障', subtitle: '持有全国性CDN、IDC、ISP、云存储全品类牌照，覆盖互联网/金融/运营商等敏感行业，合作零政策风险'},
                {title: '超大规模资源网络', subtitle: '全国34省级行政区10W + 边缘节点，10T+储备带宽，峰值承载500 万/秒并发,大促零卡顿'},
                {title: '自研智能引擎', subtitle: '神鸟云调度分发系统，自动匹配“用户-权益-节点”，降低50%运营人力+30%权益浪费率'},
                {title: '多行业方案复用', subtitle: '沉淀20+行业标准化方案，服务百度（企业福利）、腾讯（会员分发）等，3天内快速落地'},
            ],
            swiperOptions: {
                autoplay: { delay: 3000 },
                pagination: {
                    el: ".swiper-pagination",
                    clickable: false,
                },
                loop: true,
                allowTouchMove: false,
                grabCursor: false,
                noSwiping: false,
                on: {
                    init(swiper) {
                        console.log("Swiper initialized");
                    },
                },
            },
            swiperOptions1: {
                slidesPerView: 3, // 同时显示4张图片
                spaceBetween: 40, // 图片间距
                centeredSlides: true, // 居中显示
                loop: true, // 循环模式
                autoplay: {
                    delay: 1500, // 3秒自动切换
                    // disableOnInteraction: true // 用户交互后继续自动播放
                },
                speed: 500, // 切换速度
            },
            isPaused: false,
            animationId: null,
            ulDom: null

        };
    },
    methods: {
        
    }
};
</script>

<style lang="less" scoped>
@primary-color: #8dbefe;

.content-wrapper {
    // padding: 0 0 30px 0;
    width: 100%;
    background-color: #ffffff;

    .swiper-container {
        width: 100%;
        height: 500px;

        .banner-img {
            width: 100%;
            height: 100%;
        }

        /deep/ .swiper-slide {
            position: relative;

            .text {
                width: 400px;
                position: absolute;
                top: 150px;
                left: 17%;
                animation: bannerAn 0.8s ease-in-out 0.4s backwards;

                .title {
                    font-size: 36px;
                    color: #333333;
                    font-weight: bold;
                }

                .subtitle {
                    color: #666666;
                    font-size: 16px;
                    margin-top: 30px;
                }
            }

        }


    }

    .swiper-pagination {
        position: absolute;
        bottom: 20px !important;
        left: 50%;
        transform: translateX(-50%);

        /deep/ .swiper-pagination-bullet {
            width: 18px;
            height: 4px;
            background: rgba(255, 255, 255, 0.5);
            border-radius: 20%;
            margin: 0 8px !important;
            transition: all 0.3s;
            opacity: 1;
        }

        /deep/ .swiper-pagination-bullet-active {
            background: @primary-color;
            transform: scale(1.2);
            box-shadow: 0 0 10px rgba(255, 255, 255, 0.8);
        }
    }

    .data-display {
        padding: 70px 160px;
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        align-items: center;
        justify-content: space-evenly;
        box-shadow: rgba(47, 107, 228, 0.06) 0px 3px 6px 1px;
        .data-item {
            display: flex;
            flex-direction: row;
            align-items: center;

            img {
                width: 80px;
            }

            .text {
                margin-left: 10px;

                .num {
                    font-size: 28px;
                    font-weight: bold;
                    position: relative;

                    .unit {
                        position: absolute;
                        top: 0;
                        // right: -20px;
                        font-size: 16px;
                        font-weight: 300;
                    }
                }

                .desc {
                    color: #888888;
                }
            }

        }

    }
    .wrap-bg {
        background-color: #f7f9ff;
    }
    .public-box {
        padding: 70px 15%;
        
        .title {
            text-align: center;
            font-size: 30px;
            margin-bottom: 30px;
        }

        .slide {
            display: flex;
            flex-wrap: nowrap;
            justify-content: center;
            width: 100%;
            height: 360px;
            box-sizing: border-box;
            .swiper-container {
                width: 100%;
                height: 100%;
                .item {
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                    border-radius: 8px;
                    transition: all 0.5s ease;
                    background-repeat: no-repeat;
                    background-size: 100% 100%;
                    padding: 50px 30px 0 30px;
                    box-sizing: border-box;
                    .mini-title {
                        font-size: 18px;
                        margin-bottom: 20px;
                    }
                    .subtitle {
                        font-size: 12px;
                        color: #666666;
                    }
                }
            }

            // 激活的幻灯片放大效果
            /deep/ .swiper-slide-active {
                .item {
                    transform: scale(1.2);
                }
            }

            // 非激活幻灯片缩小效果
            /deep/ .swiper-slide {
                opacity: 0.7;
                transition: all 0.5s ease;

                &.swiper-slide-prev,
                &.swiper-slide-next {
                    .item {
                        transform: scale(0.9);
                    }
                }
            }
        }

        .imgList {
            display: flex;
            width: 100%;
            height: 90px;
            overflow: hidden;
            position: relative;
            margin-bottom: 30px;
            .list {
                display: flex;
                align-items: center;

            }
            .item {
                height: 80px;
                border: 1px solid #dddddd;
                border-radius: 20px;
                padding: 0 10px;
                box-sizing: border-box;
                display: flex;
                align-items: center;
                margin-right: 30px;
                background-color: #fdfdfd;
                img {
                    height: 70%;
                }
                
            }
            .l-list {
                animation: scroll 16s linear infinite; 
            }

            .r-list {
                 animation: roll-right 16s linear infinite; 
            }
            @keyframes scroll {
                from {
                    transform: translateX(0); /* 开始位置 */
                }
                to {
                    transform: translateX(-100%); /* 结束位置，根据卡片数量调整 */
                }
            }

            @keyframes roll-right {
                0% {
                    transform: translateX(-100%);
                }
                100% {
                    transform: translateX(0);
                }
            }
        }
    }


}
</style>


// WEBPACK FOOTER //
// src/views/index/content.vue